<template>
  <ux-form
    class="debugg x-border-50 x-margin x-height-100 x-scrollbar-show"
    ref="form"
    :data="formData"
    @confirm="confirm"
    :hideClose="true"
    :colon="true"
    :confirmText="$t('HT.options.env2')"
    :rules="rules"
    label-width="100px"
    data-automation="debugg"
  >
    <!-- 选择API start -->
    <ux-form-item label="API" prop="apiId">
      <!-- <my-select  class="input-width" v-model="formData.apiId" :list="apiList" label="name" value="id" :popper-append-to-body="false"></my-select> -->
      <el-input class="pro-ipt" v-model="productFormInfo.name" size="small" readonly></el-input>
    </ux-form-item>
    <!-- 选择API end -->

    <!-- 方法和域名 start -->
    <ux-form-item :label="$t('HT.debug1.domains')" prop="domain" :optionText="false">
      <span class="info-method">{{ productFormInfo.request_vo.method }}</span>
      <span class="info-protocol">{{ productFormInfo.protocol }}://</span>
      <!-- <span class="info-protocol">{{productDomains[0]}}</span> -->
      <my-select
        @change="getDomainInfo"
        class="input-width"
        v-model="formData.domain"
        :list="domainUrl"
        value="domain"
        label="domain"
        :popper-append-to-body="false"
      ></my-select>

      <span class="info-protocol">{{ productFormInfo.request_vo.uri }}</span>
    </ux-form-item>
    <!-- 方法和域名 end -->

    <!-- Path  -->
    <ux-form-item v-if="pathCount > 0" label="Path" start>
      <div v-for="(item, index) in productFormInfo.request_vo.parameters" class="item-requst">
        <div
          class="x-flex-align input-width x-margin-b"
          v-if="item.position === 'Path'"
          :key="index"
        >
          <el-input
            v-model="productFormInfo.request_vo.parameters[index].name"
            size="small"
            readonly
          ></el-input>
          <span class="x-margin-x">=</span>
          <el-input
            v-model="path[item.name]"
            size="small"
            :placeholder="item.required ? $t('HT.required') : ''"
          ></el-input>
        </div>
      </div>
    </ux-form-item>
    <!-- Header start-->
    <ux-form-item
      v-if="
        productFormInfo.request_vo &&
        productFormInfo.request_vo.transfer_type != 'PASS_THROUGH' &&
        headerCount > 0
      "
      label="Header"
      start
    >
      <div v-for="(item, index) in productFormInfo.request_vo.parameters" class="item-requst">
        <div
          class="x-flex-align input-width x-margin-b"
          v-if="item.position === 'Header'"
          :key="index"
        >
          <el-input
            v-model="productFormInfo.request_vo.parameters[index].name"
            size="small"
            readonly
          ></el-input>
          <span class="x-margin-x">=</span>
          <el-input
            v-model="header[item.name]"
            size="small"
            :placeholder="item.required ? $t('HT.required') : ''"
          ></el-input>
        </div>
      </div>
    </ux-form-item>
    <!-- Header end-->
    <!-- Header 透传 start -->
    <ux-form-item
      v-if="
        productFormInfo.request_vo && productFormInfo.request_vo.transfer_type === 'PASS_THROUGH'
      "
      label="Header"
      start
    >
      <div v-for="(item, index) in formData.mapping.Header" class="item-requst">
        <div class="x-flex-align input-width x-margin-b" :key="index">
          <el-input v-model="formData.mapping.Header[index]" size="small"></el-input>
          <span class="x-margin-x">=</span>
          <el-input v-model="header[formData.mapping.Header[index]]" size="small"></el-input>
          <el-button
            class="add-button"
            v-if="index == 0"
            type="primary"
            size="small"
            @click="addHeaders"
            >+</el-button
          >
          <el-button
            class="add-button"
            v-else
            type="primary"
            size="small"
            @click="delHeaders(index)"
            >-</el-button
          >
        </div>
      </div>
    </ux-form-item>
    <!-- Header 透传 end -->
    <!-- Query start-->
    <ux-form-item
      v-if="
        productFormInfo.request_vo &&
        productFormInfo.request_vo.transfer_type != 'PASS_THROUGH' &&
        queryCount > 0
      "
      label="Query"
      start
      class="item-option"
    >
      <div v-for="(item, index) in productFormInfo.request_vo.parameters" class="item-requst">
        <div
          class="x-flex-align input-width x-margin-b"
          v-if="item.position === 'Query'"
          :key="index"
        >
          <el-input
            v-model="productFormInfo.request_vo.parameters[index].name"
            size="small"
            readonly
          ></el-input>
          <span class="x-margin-x">=</span>
          <el-input
            v-model="query[item.name]"
            size="small"
            :placeholder="item.required ? $t('HT.required') : ''"
          ></el-input>
        </div>
      </div>
    </ux-form-item>
    <!-- Query end-->
    <!-- Query 透传 start-->
    <ux-form-item
      v-if="
        productFormInfo.request_vo && productFormInfo.request_vo.transfer_type === 'PASS_THROUGH'
      "
      label="Query"
      start
      class="item-option"
    >
      <div v-for="(item, index) in formData.mapping.Query" class="item-requst">
        <div class="x-flex-align input-width x-margin-b" :key="index">
          <el-input v-model="formData.mapping.Query[index]" size="small"></el-input>
          <span class="x-margin-x">=</span>
          <el-input v-model="query[formData.mapping.Query[index]]" size="small"></el-input>
          <el-button
            class="add-button"
            v-if="index == 0"
            type="primary"
            size="small"
            @click="addQuerys"
            >+</el-button
          >
          <el-button class="add-button" v-else type="primary" size="small" @click="delQuerys(index)"
            >-</el-button
          >
        </div>
      </div>
    </ux-form-item>
    <!-- Query 透传 end-->

    <ux-form-item :label="$t('HT.debug1.reponse')" start prop="reponse">
      <el-input
        v-model="response"
        type="textarea"
        size="small"
        readonly
        :autosize="{ minRows: 15, maxRows: 15 }"
      ></el-input>
    </ux-form-item>
    <!-- <my-footer-btn spacing="80px" padding="10px" hideClose confirmText="测 试" @confirm="confirm"></my-footer-btn> -->
  </ux-form>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        apiId: '', // API id
        env: '', // 环境
        apiGroup: '', //API分组
        domain: '', //域名列表

        safety: {
          type: '',
          AppCode: '',
          AppKey: '',
          AppSecret: ''
        }, //选择认证
        params: {
          Path: '',
          Header: '',
          Query: ''
        },
        mapping: {
          Path: '',
          Header: '',
          Query: ''
        }
      },
      path: {}, // 发送参数
      header: {}, // 发送参数
      query: {}, // 发送参数
      apiList: [], // API列表
      envList: [], // 可选环境
      info: {}, // API 详情
      response: '', // 响应
      type: '', // 根据开发和用户获取不同接口
      apiGroupList: [], //api分组
      rules: this.$rul.testApi2(),
      headContent: '', //header内容
      headType: '', //header类型
      headerList: [1],
      domainUrl: [], //域名列表
      domainInfo: '', //选中的域名,
      envInfo: '',
      flag: false,
      params: [],
      queryCount: 0, //用于Query的显示和隐藏
      headerCount: 0, //用于Header的显示和隐藏
      pathCount: 0, //用于Path的显示和隐藏
      productFormInfo: JSON.parse(this.$route.query.params),
      productDomains: []
    };
  },

  methods: {
    // 获取选择的域名
    getDomainInfo(domainString) {
      this.domainInfo = domainString;
    },
    //用于是否展示query header path
    handlerParams(val) {
      this.queryCount = this.headerCount = this.pathCount = 0;
      for (let item of val) {
        if (item.position == 'Query') {
          this.queryCount++;
        } else if (item.position == 'Header') {
          this.headerCount++;
        } else if (item.position == 'Path') {
          this.pathCount++;
        }
      }
    },
    /**
     * 测试发送请求
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let start = this.productFormInfo.request_vo.uri.indexOf('{');
          let end = this.productFormInfo.request_vo.uri.indexOf('}');
          let url = this.productFormInfo.request_vo.uri;
          if (start > -1 && end > -1) {
            for (const key in this.query) {
              url = url.replace(`{${key}}`, this.query[key]);
            }
          }

          let config = {
            config: true
          };
          let myquery = {};
          Object.assign(myquery, this.path, this.query, this.header);
          let arr = Object.keys(myquery);
          for (let i of arr) {
            if (i == '') {
              delete myquery[i];
            }
          }
          const postData = {
            url: `${this.productFormInfo.protocol}://${this.domainInfo}${this.productFormInfo.request_vo.uri}`,
            parameters: myquery
          };
          this.test(postData, this.productFormInfo.id, config);
        }
      });
    },

    /**
     * API 调试
     * @param {Object} params 参数对象
     * @param {Object} config 请求config
     */
    test(params, apiId, config) {
      this.$uxLoading.show();
      this.$api.api
        .test(params, apiId, config)
        .then((res) => {
          this.response = this.$writeHtml(res);
        })
        .catch((err) => {
          this.response = this.$writeHtml(err.response.data);
        });
    },
    // 将domainUrl改变成对象数组
    changeDomainUrl(domains) {
      // this.domainUrl = domains
      this.domainUrl = [];
      for (let i = 0; i < domains.length; i++) {
        this.domainUrl.push({ domain: domains[i] });
      }
    },
    /**
     * 添加Querys
     */
    addQuerys() {
      this.formData.mapping.Query.push('');
    },
    /**
     * 添加Header
     */
    addHeaders() {
      this.formData.mapping.Header.push('');
    },

    /**
     * 删除Querys
     */
    delQuerys(index) {
      this.formData.mapping.Query.splice(index, 1);
    },
    /**
     * 删除Headers
     */
    delHeaders(index) {
      this.formData.mapping.Header.splice(index, 1);
    }
  },
  created() {
    let userData = this.$store.state.login.userData;
    this.type = userData.type == 'FRONT' ? 'service' : 'api';

    this.productDomains = this.productFormInfo.domains;
    // this.domainUrl = this.productFormInfo.domains;
    this.changeDomainUrl(this.productFormInfo.domains);
    this.handlerParams(this.productFormInfo.request_vo.parameters);
    this.formData.mapping.Query = this.formData.mapping.Query.split(',');
    this.formData.mapping.Header = this.formData.mapping.Header.split(',');
    this.formData.mapping.Path = this.formData.mapping.Path.split(',');
  },
  computed: {
    safetyList() {
      return this.formData.safety;
    },
    backheader() {
      return JSON.parse(JSON.stringify(this.formData.mapping.Header));
    },
    backquery() {
      return JSON.parse(JSON.stringify(this.formData.mapping.Query));
    }
  },

  watch: {
    safetyList: {
      handler(val) {
        this.flag = true;
        this.formData.safety = val;
      }
      // deep: true
    },
    backheader: {
      handler(val, old) {
        let res = {};
        for (let i = 0; i < val.length; i++) {
          res[val[i]] = this.header[old[i]];
        }
        this.header = res;
      },
      deep: true
    },
    backquery: {
      handler(val, old) {
        let res = {};
        for (let i = 0; i < val.length; i++) {
          res[val[i]] = this.query[old[i]];
        }
        this.query = res;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.debugg {
  box-sizing: border-box;
  padding: 20px 30px 20px 30px;

  .input-width {
    width: 400px;
  }

  .add-button {
    box-sizing: border-box;
    width: 40px;
    min-width: auto;
    margin-left: 10px;
  }

  .info-method {
    margin-right: 30px;
    color: #777f8f;
  }

  .info-protocol {
    color: #777f8f;
    margin-right: 3px;
  }
}
</style>
<style lang="scss">
.right-item {
  flex-wrap: wrap;
}

.debugg {
  .select {
    width: 15%;
  }

  .item-requst {
    width: 100%;
  }

  .safe-input {
    width: 30%;
  }

  .pro-ipt {
    width: 400px;
  }
}
</style>
